import React from "react";
import ModalWrapper from "./ModalWrapper";

export default function StandardModal({
  width = "70%",
  padding = 15,
  component,
}) {
  return (
    <ModalWrapper
      modalClassName="modal-ux-wrapper"
      showDuration={450}
      hideDuration={200}
      style={{ width, padding }}
    >
      {component}
    </ModalWrapper>
  );
}
